import {
  APPROVED_PRODUCTS_LIST_REQUEST,
  APPROVED_PRODUCTS_LIST_RESPONSE,
  APPROVE_PRODUCT_REQUEST,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_RESPONSE,
  PRODUCT_VERSION_DETAILS_REQUEST,
  PRODUCT_VERSION_DETAILS_RESPONSE,
  REJECT_PRODUCT_REQUEST,
  REVIEW_REQUESTS_LIST_REQUEST,
  REVIEW_REQUESTS_LIST_RESPONSE
} from "./types";

export const reviewRequestsListRequest = (payload) => ({
  type: REVIEW_REQUESTS_LIST_REQUEST,
  payload
});

export const reviewRequestsListResponse = (payload) => ({
  type: REVIEW_REQUESTS_LIST_RESPONSE,
  payload
});

export const approvedProductsListRequest = (payload) => ({
  type: APPROVED_PRODUCTS_LIST_REQUEST,
  payload
});

export const approvedProductsListResponse = (payload) => ({
  type: APPROVED_PRODUCTS_LIST_RESPONSE,
  payload
});

export const approveProductRequest = (payload) => ({
  type: APPROVE_PRODUCT_REQUEST,
  payload
});

export const rejectProductRequest = (payload) => ({
  type: REJECT_PRODUCT_REQUEST,
  payload
});

export const productDetailsRequest = (payload) => ({
  type: PRODUCT_DETAILS_REQUEST,
  payload
});

export const productDetailsResponse = (payload) => ({
  type: PRODUCT_DETAILS_RESPONSE,
  payload
});

export const productVersionDetailsRequest = (payload) => ({
  type: PRODUCT_VERSION_DETAILS_REQUEST,
  payload
});

export const productVersionDetailsResponse = (payload) => ({
  type: PRODUCT_VERSION_DETAILS_RESPONSE,
  payload
});
